import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AngularFireModule } from '@angular/fire/compat';
import { environment } from 'src/environments/environment';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { GoogleMapsModule } from '@angular/google-maps';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { UnrTokenInterceptor } from './core/http/unr-token.interceptor';
import { UnrAuthModule } from './core/auth/auth.module';
import { NativeModule } from './core/native/native.module';
import { FeedbackModule } from './feedback/feedback.module';
import { MyRoutesPageModule } from './pages/my-routes/my-routes.module';
import { NoConnectionComponent } from './pages/no-connection/no-connection.component';
import { ProfilePageModule } from './pages/profile/profile.module';
import { RoadtripDetailsPageModule } from './pages/roadtrip-details/roadtrip-details-page.module';
import { SettingsPageModule } from './pages/settings/settings.module';
import { StepDetailsModule } from './pages/step-details/step-details.module';
import { TutorialPageModule } from './pages/tutorial/tutorial.module';
import { PrivacyPageModule } from './pages/privacy/privacy.module';
import { WelcomePage } from './pages/welcome/welcome';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AdsmodalPageModule } from './adsmodal/adsmodal.module';
import { CommonModule } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { initializeApp } from 'firebase/app';

// ✅ Initialize Firebase for Capacitor Firebase plugins
initializeApp(environment.firebase);

@NgModule({
  declarations: [
    AppComponent,
    NoConnectionComponent,
    WelcomePage
  ],
  imports: [
    BrowserModule,
    CommonModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    HttpClientModule,
    NativeModule,
    FeedbackModule,
    UnrAuthModule,
    StepDetailsModule,
    RoadtripDetailsPageModule,
    TutorialPageModule,
    PrivacyPageModule,
    MyRoutesPageModule,
    ProfilePageModule,
    SettingsPageModule,
    AdsmodalPageModule,
    GoogleMapsModule,
    NgxSkeletonLoaderModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerImmediately'
    }),

  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnrTokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
